(function () {
  "use strict";

  function hasBothApps() {
    return document.querySelector(".hulkapps_option") &&
      (document.getElementById("customily-personalize-button") || document.getElementById("customily-cart-btn"));
  }

  if (!hasBothApps()) return;

  var lastKnownGood = {};

  function optionKey(opt) {
    var hidden = opt.querySelector('input[type="hidden"][name^="properties["]');
    if (hidden && hidden.name) return hidden.name;
    var radio = opt.querySelector('input[type="radio"]');
    return radio ? radio.name : null;
  }

  function snapshot() {
    document.querySelectorAll(".hulkapps_option").forEach(function (opt) {
      var key = optionKey(opt);
      if (!key) return;
      var checked = opt.querySelector('input[type="radio"]:checked');
      if (checked) {
        var hidden = opt.querySelector('input[type="hidden"][name^="properties["]');
        lastKnownGood[key] = {
          radioName: checked.name,
          radioValue: checked.value,
          hiddenValue: hidden ? hidden.value : null
        };
      }
    });
  }

  function restoreIfReset() {
    document.querySelectorAll(".hulkapps_option").forEach(function (opt) {
      var key = optionKey(opt);
      if (!key) return;
      var saved = lastKnownGood[key];
      if (!saved) return;
      if (!opt.querySelector('input[type="radio"]:checked')) {
        var radios = opt.querySelectorAll('input[type="radio"]');
        var target = null;
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].name === saved.radioName && radios[i].value === saved.radioValue) {
            target = radios[i];
            break;
          }
        }
        if (target) {
          target.checked = true;
          target.dispatchEvent(new Event("input", { bubbles: true }));
          target.dispatchEvent(new Event("change", { bubbles: true }));
          target.dispatchEvent(new Event("click", { bubbles: true }));
        }
        var hidden = opt.querySelector('input[type="hidden"][name^="properties["]');
        if (hidden && !hidden.value && saved.hiddenValue) {
          hidden.value = saved.hiddenValue;
        }
        opt.classList.remove("validation_error");
      }
    });
  }

  document.addEventListener("change", function (e) {
    if (e.target.closest && e.target.closest(".hulkapps_option")) {
    lastUserInteraction = Date.now();
    snapshot();
    }
    }, true);

    document.addEventListener("click", function (e) {
    if (e.target.closest && e.target.closest(".hulkapps_option")) {
    lastUserInteraction = Date.now();
    snapshot();
    }
    if (e.target.closest && (e.target.closest("#customily-cart-btn") || e.target.closest("#customily-personalize-button"))) {
    lastUserInteraction = Date.now();
    snapshot();
    }
    }, true);

    document.addEventListener("DOMContentLoaded", snapshot);
    snapshot();

    var lastUserInteraction = 0;
    var GRACE_PERIOD_MS = 400;
    var debounceTimer = null;
    var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
    if (Date.now() - lastUserInteraction < GRACE_PERIOD_MS) return;
    restoreIfReset();
    }, 80);
    });
    var observerScope = document.querySelector(".product-form") || document.body;
    observer.observe(observerScope, { childList: true, subtree: true });
    })();